import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"



import {
  CheckboxChangeEventDetail,
  IonCheckbox,
  IonItem,
  IonLabel,
} from '@ionic/vue';
import { IonCheckboxCustomEvent } from '@ionic/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'CourseletChoice',
  props: {
    label: null,
    value: null,
    checked: { type: Boolean }
  },
  emits: ["checked"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'checked', event: { checked: boolean; value: string }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  label: string;
  value: string;
  checked: boolean;
}





const onChecked = (
  event: IonCheckboxCustomEvent<CheckboxChangeEventDetail<string>>
) => {
  emit('checked', { checked: event.detail.checked, value: props.value });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonItem), { class: "ion-text-center" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonCheckbox), {
        slot: "start",
        value: props.value,
        checked: props.checked,
        onIonChange: onChecked
      }, null, 8, ["value", "checked"]),
      _createVNode(_unref(IonLabel), null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.label), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})